import React from 'react';
import {LinkContainer} from 'react-router-bootstrap';
import './MainView.css';


const Properties = props => {
	if (!props.properties) {
		return (
			<div>
				Loading...
			</div>
		);
	}

	return(
		<div>
			{
				props.properties.map(property => {
					return (
						
						<div className="col-xs-12 col-lg-6 center-block text-center groupCont" key={property._id}>
							<div className="row group" >

								<div className="col-sm-7 col-md-5 col-lg-5 imagePort">
									<div className="thumbnail property">
										<LinkContainer to={`/groups?group=${property._id}`}>
											<img className="propertyImg" src={property.thumbnail}/>
										</LinkContainer>
									</div>
								</div>
								<div className="col-sm-5 col-md-7 col-lg-7 textPort">
									<LinkContainer to={`/groups?group=${property._id}`}>
											<a id="propName">{property.name}</a>
									</LinkContainer>
									<p className="propDes">
										{property.description}
									</p>
									<p className="address" >{property.address}</p>
								</div>
							</div>
						
						
						</div>
					);
				})
			}
		</div>
	);
}

export default Properties;


// WEBPACK FOOTER //
// ./src/components/Properties.js